import React, { Fragment } from 'react'
import { Typography, SpacerVertical } from '@klarna/bubble-ui'
import styles from './LegalText.css'
import LegalLink from '../../../common/components/LegalLink'

type LegalTextProps = {
  legalText: string
  legalLinkText?: string
  legalLink?: string
  alignText?: string
}

const LegalText: React.FC<LegalTextProps> = ({
  legalText = '',
  legalLinkText = '',
  legalLink = '',
  alignText = 'text-alignment/start'
}) => legalText && (
  <Fragment>
    <style>{styles}</style>
    <SpacerVertical spaceToken= 'space.0' />
    <Typography textToken= 'text-style/text/super-paragraphs/tiny/regular' colorToken='colors/text/neutral' textAlignToken={alignText}>
      <LegalLink textToken={'text-style/text/super-paragraphs/tiny/regular'}
        colorToken={'colors/text/subtle'}
        legalText = {legalText}
        legalLinkText = {legalLinkText}
        legalLink ={legalLink} />
    </Typography>
    <SpacerVertical spaceToken= 'space.400' />
  </Fragment>
)

export default LegalText
